import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Breadcrumb, Grid, Row, Col, Panel, ButtonToolbar, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Field } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import ConfirmActionModal from '../Common/confirmActionModal';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import { DateFormatter } from '../Common/dateFormat';
import { DisabledInputField } from '../Common/inputField';
import { ROOT_URL } from '../../actions/root_url';
import { toFromDates } from '../Common/cleanDates';
import CashFormatter from '../Common/cashFormatter';
import { numberWithCommas } from '../Common/numberWithCommas';
import checkPermission from '../Common/permissions';

momentLocalizer(moment);

const getBsStyle = (input, value) => ((input === value) ? 'success' : 'primary');

const renderRadios = props => {
  const renderStartDatePicker = (days) => {
    if (days === '-1') {
      return (
        <Button bsStyle='primary'>
          <Field name='FromDate' placeholder={'Start'} component={DatePicker} />
        </Button>
      );
    }
    return (
      <Button bsStyle='primary'>
        <Field name='FromDate' placeholder={'Start'} component={DisabledDatePicker} />
      </Button>
    );
  };
  const renderEndDatePicker = (days) => {
    if (days === '-1') {
      return (
        <Button bsStyle='primary'>
          <Field name='ToDate' placeholder={'End'} component={DatePicker} />
        </Button>
      );
    }
    return (
      <Button bsStyle='primary'>
        <Field name='ToDate' placeholder={'End'} component={DisabledDatePicker} />
      </Button>
    );
  };
  return (
    <ButtonToolbar className='radio-filter-buttons'>
      <Button bsStyle={getBsStyle(props.input.value, '1')}>
        <div className='radio'>
          <label htmlFor='today-radio-filter'>
            <input
              {...props.input}
              id='today-radio-filter'
              type='radio'
              name='dateFilterRadios'
              value='1'
              onClick={() => { props.fetchAP(1); }}
              checked={props.input.value === '1'}
            />
            <Translate value="today" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '7')}>
        <div className='radio'>
          <label htmlFor='sevenDay-radio-filter'>
            <input
              {...props.input}
              id='sevenDay-radio-filter'
              type='radio'
              name='dateFilterRadios'
              value='7'
              onClick={() => { props.fetchAP(7); }}
              checked={props.input.value === '7'}
            />
            7 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '30')}>
        <div className='radio'>
          <label htmlFor='thirtyDay-radio-filter'>
            <input
              {...props.input}
              id='thirtyDay-radio-filter'
              type='radio'
              name='dateFilterRadios'
              value='30'
              onClick={() => { props.fetchAP(30); }}
              checked={props.input.value === '30'}
            />
            30 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '90')}>
        <div className='radio'>
          <label htmlFor='ninetyDay-radio-filter'>
            <input
              {...props.input}
              id='ninetyDay-radio-filter'
              type='radio'
              name='dateFilterRadios'
              value='90'
              onClick={() => { props.fetchAP(90); }}
              checked={props.input.value === '90'}
            />
            90 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '-1')}>
        <div className='radio'>
          <label htmlFor='dateRange-radio-filter'>
            <input
              {...props.input}
              id='dateRange-radio-filter'
              type='radio'
              name='dateFilterRadios'
              value='-1'
              checked={props.input.value === '-1'}
            />
            <Translate value="date_range" />
          </label>
        </div>
      </Button>
      {renderStartDatePicker(props.days)}
      {renderEndDatePicker(props.days)}
      {/* <Button
        bsStyle='primary'
        className='search-btn'
        type='submit'
        onClick={() => { props.fetchAP(-1); }}
      >
        <em className='fa fa-search' />
      </Button> */}
    </ButtonToolbar>
  );
};

class APList extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            ap: {
              rows: [],
              selectedRows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null
            },
            apDetail: {
              rows: [],
              selectedRows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null
            },
            apOpen: false,
            vendor: null,
            payment_id: null,
            title: '',
            total: 0,
            fromDate: '1900-01-01',
            toDate: '3000-01-01',
            rowsCount: 0,
        };
        this.fetchAP = this.fetchAP.bind(this);
        this.editAP = this.editAP.bind(this);
        this.createAP = this.createAP.bind(this);
    }

    componentDidMount() {
      const fromDate = '1900-01-01';
      const toDate = '3000-01-01';
      const days = '7';
      this.props.setDefaultOfForm('Days', '7', 'apList');
      this.props.fetchAP(fromDate, toDate, days);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.ap && nextProps.ap !== this.props.ap) {
        const ap = { ...this.state.ap, rows: nextProps.ap.Payments };
        this.setState({ ap, total: nextProps.ap.Total });
      }
      if (nextProps.apDetail && nextProps.apDetail !== this.props.apDetail) {
        const apDetail = { ...this.state.apDetail, rows: nextProps.apDetail.Invoices };
        this.setState({ apDetail });
      }
      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
        this.closeCheckAuthorize();
        this.voidAP();
      }
      if (nextProps.days !== this.props.days) {
        this.props.setDefaultOfForm('FromDate', null, 'apList');
        this.props.setDefaultOfForm('ToDate', null, 'apList');
      }
      if (nextProps.fromDate && nextProps.fromDate !== this.props.fromDate) {
        this.setState({ fromDate: nextProps.fromDate }, this.fetchAP);
      }
      if (nextProps.toDate && nextProps.toDate !== this.props.toDate) {
        this.setState({ toDate: nextProps.toDate }, this.fetchAP);
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.ap !== this.state.ap) {
        this.setState({ rowsCount: Data.Selectors.getRows(this.state.ap).length });
      }
    }

    voidAP() {
      this.state.ap.selectedRows.map(row => {
        this.props.deleteAP(row.Payment_id).then(() => {
          this.fetchAP();
        });
      });
      // let newRows = this.state.ap.rows;
      // this.state.ap.selectedRows.map(row => {
      //   this.props.deleteAP(row.Payment_id);
      //   newRows = newRows.filter((obj) => obj !== row);
      //   const ap = { ...this.state.ap, rows: newRows };
      //   this.setState({ ap });
      // });
    }

    fetchAP(days) {
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      if (this.state.fromDate != null) {
        fromDate = moment(this.state.fromDate).format('YYYY-MM-DD');
      }
      if (this.state.toDate != null) {
        toDate = moment(this.state.toDate).format('YYYY-MM-DD');
      }
      this.props.fetchAP(fromDate, toDate, days);
    }

    editAP() {
      this.props.fetchAPDetail(this.state.ap.selectedRows[0].Payment_id).then(
        () => { this.context.router.push(`/AP/${this.state.ap.selectedRows[0].Payment_id}`); }
      );
    }

    createAP() {
      this.props.clearAPDetail();
      this.context.router.push('/AP/new');
    }

    checkAuthorize = (password) => {
      this.props.checkPassword(password);
    }

    openCheckAuthorize = (action) => {
      this.props.clearCheckPassword();
      this.setState({ checkAuthorizeOpen: true, action });
    }

    closeCheckAuthorize = () => {
      this.setState({ checkAuthorizeOpen: false });
    }

    renderTable() {
        if (this.props.isLoading && !this.props.error) {
          return <Spinner />;
        } else if (this.props.error) {
          return (
            <ContentWrapper>
              <div className='alert alert-danger'>
                <Translate value="something_unexpected_happened" />
              </div>
            </ContentWrapper>
          );
        }
        // Parameters of the react-data-grid
        const getRows = () => Data.Selectors.getRows(this.state.ap);

        const getSize = () => getRows().length;

        const rowGetter = rowIdx => {
            const rows = getRows();
            return rows[rowIdx];
        };

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            const ap = Object.assign({}, this.state.ap, { sortColumn, sortDirection });
            this.setState({ ap });
        };

        const handleFilterChange = filter => {
            const newFilters = Object.assign({}, this.state.ap.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            const ap = { ...this.state.ap, filters: newFilters };
            this.setState({ ap });
        };

        const onClearFilters = () => {
             //all filters removed
             const ap = { ...this.state.ap, filters: {} };
             this.setState({ ap });
        };

        // Handle the row select function

        const onRowsSelected = (rows) => {
             const newRows = getRows();
             const selectedRows = [];
             newRows.map(r => {
               r.isSelected = false;
             });
             rows.map(r => {
               newRows[r.rowIdx].isSelected = true;
               selectedRows.push(r.row);
             });
             const ap = { ...this.state.ap, rows: newRows, selectedRows };
             this.setState({ ap });
        };

         const onRowsDeselected = (rows) => {
             const newRows = getRows();
             rows.map(r => {
               newRows[r.rowIdx].isSelected = false;
             });
             const selectedRows = [];
             const ap = { ...this.state.ap, rows: newRows, selectedRows };
             this.setState({ ap });
         };

         const onRowClick = (rowIdx, row) => {
           if (rowIdx > -1) {
             this.props.fetchAPDetail(row.Payment_id);
           }
         };

        // Column difinition

        const columns = [
          {
              key: 'APNum',
              name: <Translate value="ap_num" />,
              width: 110,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'PaymentDate',
              name: <Translate value="pmt_date" />,
              width: 90,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: DateFormatter
          },
          {
              key: 'PostingDate',
              name: <Translate value="create_time" />,
              width: 90,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: DateFormatter
          },
          {
              key: 'VendorName',
              name: <Translate value="vendor_name" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'Description',
              name: <Translate value="description" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'Method',
              name: <Translate value="method" />,
              width: 80,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'CheckNum',
              name: <Translate value="check" />,
              width: 80,
              resizable: true,
              sortable: true,
              filterable: true,
          },
          {
              key: 'TotalPayment',
              name: <Translate value="amount" />,
              width: 80,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: CashFormatter,
          },
          {
              key: 'AccountName',
              name: <Translate value="account" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'Status',
              name: <Translate value="status" />,
              width: 70,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'Note',
              name: <Translate value="note" />,
              resizable: true,
              sortable: true,
              filterable: true
          },
        ];

        return (
          <Row>
            <Col sm={12}>
              <div style={{ maxWidth: '100%' }} id="APList-dataGrid1">
                <ReactDataGrid
                  onGridSort={handleGridSort}
                  toolbar={<Toolbar enableFilter />}
                  onAddFilter={handleFilterChange}
                  onClearFilters={onClearFilters}
                  columns={columns}
                  rowHeight={25}
                  headerRowHeight={45}
                  minHeight={320}
                  enableRowSelect='single'
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  onRowClick={onRowClick}
                  rowSelection={{
                    showCheckbox: true,
                    enableShiftSelect: true,
                    onRowsSelected,
                    onRowsDeselected,
                    selectBy: {
                     isSelectedKey: 'isSelected'
                    }
                  }}
                />
              </div>
            </Col>
          </Row>
        );
    }

    renderDetailTable() {
        if (this.props.apDetailIsLoading && !this.props.apDetailError) {
          return <Spinner />;
        } else if (this.props.apDetailError) {
          return (
            <ContentWrapper>
              <div className='alert alert-danger'>
                <Translate value="something_unexpected_happened" />
              </div>
            </ContentWrapper>
          );
        }
        // Parameters of the react-data-grid

        const getRows = () => Data.Selectors.getRows(this.state.apDetail);

        const getSize = () => getRows().length;

        const rowGetter = rowIdx => {
            const rows = getRows();
            return rows[rowIdx];
        };

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            const apDetail = Object.assign({}, this.state.apDetail, { sortColumn, sortDirection });
            this.setState({ apDetail });
        };

        // Column difinition

        const columns = [
          {
              key: 'ReceiveNum',
              name: <Translate value="receive_num" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'InvoiceNum',
              name: <Translate value="invoice_no" />,
              resizable: true,
              width: 150,
              sortable: true,
              filterable: true
          },
          {
              key: 'PostingDate',
              name: <Translate value="receive_date" />,
              width: 120,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: DateFormatter
          },
          {
              key: 'Name',
              name: <Translate value="vendor_name" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'Description',
              name: <Translate value="description" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'UnpaidAmount',
              name: <Translate value="balance" />,
              width: 80,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: CashFormatter,
          },
          {
              key: 'Amount',
              name: <Translate value="payment" />,
              width: 80,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: CashFormatter,
          },
          {
              key: 'DiscountedAmount',
              name: <Translate value="discount" />,
              width: 85,
              resizable: true,
              filterable: true,
              formatter: CashFormatter,
          },
          {
              key: 'Note',
              name: <Translate value="note" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
        ];

        return (
          <Row>
            <Col sm={12}>
              <div style={{ maxWidth: '100%' }} id="APList-dataGrid2">
                <ReactDataGrid
                  onGridSort={handleGridSort}
                  columns={columns}
                  rowHeight={25}
                  minHeight={220}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                />
              </div>
            </Col>
          </Row>
        );
    }

    renderExportButton() {
      let { days } = this.props;
      const { fromDate: f, toDate: t } = this.props;
      days = days || 7;
      const { fromDate, toDate } = toFromDates(days, f, t);
      const params = `PaymentDate__gte=${fromDate}&PaymentDate__lte=${toDate}`;
      const token = localStorage.getItem('token');
      const url = `${ROOT_URL}/v1/ap/payment/export/?${params}&Bearer=${token}`;
      return (
        <Button
          bsStyle='success'
          type='button'
          href={url}
        >
          <em className='fa fa-print' />
          <Translate value="excel" />
        </Button>
      );
    }


    render() {
      const shouldRemoveDisable = this.state.ap.selectedRows.length !== 1;
      const createDialogStyle = {
          width: '550px',
          height: '300px',
          marginLeft: '-15%',
      };
      return (
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="ar_slashsign_ap" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              <Translate value="account_payable_payment_report" />
            </Breadcrumb.Item>
          </Breadcrumb> {/* End Navigation Trail */}

          <ButtonToolbar>
            { this.renderExportButton() }
          </ButtonToolbar>

          <Grid id='AP'>
            <Panel id='date-range-picker' className='form-horizontal'>
              <Row>
                <Col xs={1}>
                  <h3><Translate value="payment_date" /><span className='colon'>:</span></h3>
                </Col>
                <Col xs={11}>
                  <Field name='Days' component={renderRadios} fetchAP={this.fetchAP} days={this.props.days} />
                </Col>
              </Row>
            </Panel>
            <Panel id='ap-table' className='position-relative table-collapse-fix'>
              <ButtonToolbar className='table-buttons'>
                <Button
                  bsStyle='success'
                  onClick={this.createAP}
                  disabled={!checkPermission('add_account_payable')}
                >
                  <em className='fa fa-plus' /><Translate value="create" />
                </Button>
                <Button
                  bsStyle='warning'
                  onClick={this.editAP}
                  disabled={!this.state.ap.selectedRows || this.state.ap.selectedRows.length !== 1 || !checkPermission('change_account_payable')}
                >
                  <em className='fa fa-pencil' /><Translate value="edit" />
                </Button>
                <Button
                  bsStyle='danger'
                  type='button'
                  onClick={() => { this.openCheckAuthorize('remove'); }}
                  disabled={shouldRemoveDisable || !checkPermission('delete_account_payable')}
                >
                  <em className="fa fa-trash" /><Translate value="void" />
                </Button>
              </ButtonToolbar>
              { this.renderTable() }
              <Row className="grand-total">
                <Col xs={5}>
                  <label>
                    <Translate value="rows" />:&nbsp;
                    <span className="font-color-orange">{ this.state.rowsCount }</span>
                  </label>
                </Col>
                <Col xs={6}>
                  <Col style={{ 'margin-top': '2px' }} xs={2} xsOffset={1}>
                    <span>
                      <label style={{'display': 'inline-flex'}}><Translate value="grand_total" /><span className="dollar-sign"> $$</span>:</label>
                    </span>
                  </Col>
                  <Col xs={2}>
                    <Field component={DisabledInputField} placeholder={this.state.total || 0}/>
                  </Col>
                </Col>
              </Row>
            </Panel>
            <h2><Translate value="payment_detail" /></h2>
            <Panel id='ap-table-detail' className='details-table-collapse-fix'>
              { this.renderDetailTable() }
            </Panel>
          </Grid>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.checkAuthorizeOpen}
            onCloseClicked={this.closeCheckAuthorize}
          >
            <ConfirmActionModal
              case='confirmPassword'
              closeC={this.checkAuthorize}
              checkPasswordFailure={this.props.checkPasswordFailure}
            />
          </SkyLightStateless>
        </ContentWrapper>
      );
    }
}

export default APList;



// WEBPACK FOOTER //
// ./master/jsx/components/AP/APList.jsx